import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readTotal: sesion =>
    api
      .send({
        query: gql`
          query readTotal($sesion: ID!) {
            Movimiento {
              readTotal(sesion: $sesion)
            }
          }
        `,
        variables: {
          sesion
        }
      })
      .then(result => result.data.data.Movimiento.readTotal),

  readMontosTotales: sesion =>
    api
      .send({
        query: gql`
          query readMontosTotales($sesion: ID!) {
            Movimiento {
              readMontosTotales(sesion: $sesion) {
                ingresos
                egresos
                saldo
              }
            }
          }
        `,
        variables: {
          sesion
        }
      })
      .then(result => result.data.data.Movimiento.readMontosTotales),

  readAllByEmisor: (sesion, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($sesion: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Movimiento {
              readAllByEmisor(sesion: $sesion, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  userSession {
                    _id
                    fullname
                  }
                  tipo
                  medioPago
                  montoIngreso
                  montoEgreso
                  montoServicio
                  detalle
                  saldo
                  createdAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          cursor,
          limit,
          filter,
          sesion
        }
      })
      .then(result => result.data.data.Movimiento.readAllByEmisor),

  readBySearchString: (sesion, searchString) =>
    api
      .send({
        query: gql`
          query readBySearchString($sesion: ID!, $searchString: String!) {
            Movimiento {
              readBySearchString(sesion: $sesion, searchString: $searchString) {
                feed {
                  _id
                  userSession {
                    _id
                    fullname
                  }
                  tipo
                  medioPago
                  montoIngreso
                  montoEgreso
                  montoServicio
                  detalle
                  saldo
                  createdAt
                }
              }
            }
          }
        `,
        variables: {
          searchString,
          sesion
        }
      })
      .then(result => result.data.data.Movimiento.readBySearchString),

  readByMedioPago: sesion =>
    api
      .send({
        query: gql`
          query readByMedioPago($sesion: ID!) {
            Movimiento {
              readByMedioPago(sesion: $sesion) {
                _id
                ingresos
                egresos
              }
            }
          }
        `,
        variables: {
          sesion
        }
      })
      .then(result => result.data.data.Movimiento.readByMedioPago),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: MovimientoInput!) {
            Movimiento {
              create(input: $input) {
                _id
                createdAt
                saldo
                userSession {
                  fullname
                }
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Movimiento.create)

  // readById: _id =>
  //   api
  //     .send({
  //       query: gql`
  //         query readById($_id: ID!) {
  //           Movimiento {
  //             readById(_id: $_id) {
  //               _id
  //               status
  //               state
  //               createdAt
  //               updatedAt
  //               caja {
  //                 _id
  //                 name
  //               }
  //               userSession {
  //                 _id
  //                 fullname
  //               }
  //             }
  //           }
  //         }
  //       `,
  //       variables: {
  //         _id
  //       }
  //     })
  //     .then(result => result.data.data.Movimiento.readById)
}
